import { Form } from 'react-bootstrap';
import ImageInfoPopup from './ImageInfoPopup';
import Menu from '../assets/images/menu.webp';

/**
 * Reusable checkout callout for the RSVP Dinner Package program.
 * Parent owns opt-in state when using the checkbox.
 * Optional `optInDisclaimer` overrides the message shown when the box is checked.
 */
export default function RsvpCheckoutCallout({
  className = '',
  title = 'Dinner & A Show',
  showCheckbox = false,
  optIn = false,
  onOptInChange,
  optInId = 'rsvp-dinner-opt-in',
  optInLabel = 'Free RSVP for Dinner & A Show Package',
  optInDisclaimer = null,
  disabled = false,
  infoTriggerLabel = 'View menu and package details',
}) {
  const resolvedDisclaimer =
    optInDisclaimer ??
    '⚠️ Dinner is not included in the price of this ticket. This RSVP simply reserves you a discounted menu. Your meal is ordered and paid for separately at the restaurant.';
  return (
    <aside
      className={`rounded-lg border px-3 py-3 mb-3 text-black md:px-5 md:py-4 md:shadow-sm md:border-stone-200/90 ${className}`.trim()}
      style={{
        borderColor: '#dee2e6',
        backgroundColor: '#dedede',
      }}
      aria-label="RSVP Dinner Package information"
    >
      <div className="md:min-w-0 md:flex md:flex-col md:justify-center md:gap-1">
        {/* <p
          className="text-xs font-semibold uppercase tracking-wider text-stone-600 mb-1"
          style={{ letterSpacing: '0.06em' }}
        >
          {title}
        </p> */}
        {showCheckbox && typeof onOptInChange === 'function' ? (
          <div className="w-100">
            <div className="d-flex align-items-center justify-center gap-2 md:justify-start md:gap-3 md:[&_input.form-check-input]:mt-0 md:[&_input.form-check-input]:h-[1.2rem] md:[&_input.form-check-input]:w-[1.2rem]">
              <Form.Check
                type="checkbox"
                id={optInId}
                checked={optIn}
                onChange={(e) => onOptInChange(e.target.checked)}
                disabled={disabled}
                className="mt-0"
              />
              <label
                htmlFor={optInId}
                className="large mb-0 font-semibold md:text-base md:font-semibold md:text-stone-800 md:leading-snug"
                style={{ lineHeight: 1.4 }}
              >
                {optInLabel}
              </label>
            </div>
            {optIn ? (
              <p
                className="mb-0 mt-2 text-sm text-stone-700 md:text-[0.9375rem] md:leading-snug"
                style={{ paddingLeft: '1.75rem' }}
                role="status"
              >
                {resolvedDisclaimer}
              </p>
            ) : null}
          </div>
        ) : null}
                <p className="mb-2">
          <ImageInfoPopup
            triggerLabel={infoTriggerLabel}
            imageSrc={Menu}
            imageAlt="Dinner & A Show Menu"
            disabled={disabled}
          />
        </p>
      </div>
    </aside>
  );
}
